module.exports = __webpack_public_path__ + "img/insert_tags_duplicate_edit.7ca2f59b.png";